import { useEffect } from 'react';
import { applyHeadToDocument, headDataFromRoute } from '@/seo/head';
import { absoluteUrl } from '@/seo/jsonld';
import { seoForPath } from '@/seo/routes';

interface PageMetaProps {
  title: string;
  description?: string;
}

/**
 * Título e descrição de páginas fora do layout institucional (checkout,
 * orçamento). Rota registrada em `src/seo/routes.ts` usa o registro; as demais
 * são de transação e saem com `noindex`.
 *
 * Lê o caminho de `window.location` dentro do efeito, e não de `useLocation`,
 * porque este componente também é exportado no pacote de design
 * (`src/components/index.ts`), que pode ser usado fora de um Router.
 */
export function PageMeta({ title, description }: PageMetaProps) {
  useEffect(() => {
    const pathname = window.location.pathname;
    const route = seoForPath(pathname);
    applyHeadToDocument(
      route
        ? headDataFromRoute(route)
        : { title, description: description ?? '', canonical: absoluteUrl(pathname), noindex: true },
    );
  }, [title, description]);

  return null;
}
